import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Browser } from '@capacitor/browser';

@Component({
  selector: 'app-tab-content',
  templateUrl: './tab-content.component.html',
  styleUrls: ['./tab-content.component.scss'],
})
export class TabContentComponent implements OnChanges {

  public title: string = 'Corporate safety - Crew Self Service';
  @Input() isDesktop:boolean =false;
  @Input() selectedTab:string = '';
  isFrontImageLoaded:boolean = false;
  isBackImageLoaded:boolean = false;
  public readonly noCorruptionReportingUrl: string = 'https://macn.dk/incident-reporting/';

  private readonly tabsWithBackImage: string[] = ['Open Reporting', 'Stop Work Authority'];

  get hasBackImage(): boolean {
    return this.tabsWithBackImage.includes(this.selectedTab);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedTab']) {
      this.isFrontImageLoaded = false;
      this.isBackImageLoaded = false;
    }
  }

  onImageLoad(side:string){
    if(side === 'front')
      this.isFrontImageLoaded = true;
    if(side === 'back')
      this.isBackImageLoaded = true;
  }

  openNoCorruptionReportingUrl(event: Event) {
    event.preventDefault();
    Browser.open({ url: this.noCorruptionReportingUrl });
  }
}
